import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';

/**
 * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
 * @param choicesLength {number} an overall amount of available choices
 * @returns a final choice index to select plural word by
* */
// eslint-disable-next-line no-unused-vars, consistent-return, func-names
VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
  // this === VueI18n instance, so the locale property also exists here
  if (this.locale === 'ru') {
    const teen = choice > 10 && choice < 20;

    // 21,31,41 etc
    if (!teen && choice % 10 === 1) {
      return 0;
    }

    // 22,23,24
    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
      return 1;
    }

    // 0, 11-19, 25, 26, 30
    // eslint-disable-next-line no-mixed-operators
    if (choice === 0 || choice % 10 === 0 || teen || choice % 10 >= 5 && choice % 10 <= 9) {
      return 2;
    }
  } else if (choice === 1) {
    return 0;
  } else {
    return 1;
  }
};

Vue.use(VueI18n);

const requireModule = require.context('.', false, /\.js$/);
const messages = {};

requireModule.keys().forEach((fileName) => {
  // skip this file
  if (fileName === './index.js') return;

  const lang = _.camelCase(fileName.replace(/(\.\/|\.js)/g, ''));
  messages[lang] = requireModule(fileName).default;
});

const i18n = new VueI18n({
  locale: process.env.VUE_APP_DEFAULT_LANGUAGE, // set locale
  fallbackLocale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  messages, // set locale messages
});

export default i18n;
